import React from 'react';
import { X } from 'lucide-react';
import MultiSelect from '../common/MultiSelect';
import DateInputBR from '../common/DateInputBR';
import { justiceSphereOptions } from '../../utils/justiceSphere';

export default function LeadsFilters({
  filters,
  onFilterChange,
  filterOptions,
  onClose,
  selectedView = 'ativos',
  onViewChange,
  viewTabs = [],
}) {
  const handleReset = () => {
    onFilterChange('reset', null);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-gray-900">Filtros avançados</h3>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors touch-manipulation"
            aria-label="Ocultar filtros"
            title="Ocultar filtros"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {viewTabs.length > 0 && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Status
            </label>
            <select
              value={selectedView}
              onChange={(e) => onViewChange && onViewChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900 bg-white"
            >
              {viewTabs.map((tab) => (
                <option key={tab.id} value={tab.id}>
                  {tab.label}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Data de conversão
          </label>
          <div className="flex space-x-2">
            <DateInputBR
              value={filters.convertedAtStart || ''}
              onChange={(e) =>
                onFilterChange(
                  'convertedAtStart',
                  e.target.value || undefined,
                )
              }
              placeholder="De"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900"
            />
            <DateInputBR
              value={filters.convertedAtEnd || ''}
              onChange={(e) =>
                onFilterChange(
                  'convertedAtEnd',
                  e.target.value || undefined,
                )
              }
              placeholder="Até"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900"
            />
          </div>
        </div>

        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Data de perdido
          </label>
          <div className="flex space-x-2">
            <DateInputBR
              value={filters.lostAtStart || ''}
              onChange={(e) =>
                onFilterChange(
                  'lostAtStart',
                  e.target.value || undefined,
                )
              }
              placeholder="De"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900"
            />
            <DateInputBR
              value={filters.lostAtEnd || ''}
              onChange={(e) =>
                onFilterChange(
                  'lostAtEnd',
                  e.target.value || undefined,
                )
              }
              placeholder="Até"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Tipo de Justiça
          </label>
          <MultiSelect
            options={justiceSphereOptions('filterLabel')}
            value={filters.justica || []}
            onChange={(val) => onFilterChange('justica', val)}
            placeholder="Selecione..."
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Tribunal
          </label>
          <MultiSelect
            options={(filterOptions.tribunais || []).map((item) => ({
              value: item,
              label: item,
            }))}
            value={filters.tribunal || []}
            onChange={(val) => onFilterChange('tribunal', val)}
            searchable
            placeholder="Selecione tribunais..."
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Estado
          </label>
          <MultiSelect
            options={(filterOptions.provincias || []).map((item) => ({
              value: item,
              label: item,
            }))}
            value={filters.provincia || []}
            onChange={(val) => onFilterChange('provincia', val)}
            searchable
            placeholder="Selecione estados..."
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Cidade
          </label>
          <MultiSelect
            options={(filterOptions.cidades || []).map((item) => ({
              value: item,
              label: item,
            }))}
            value={filters.cidade || []}
            onChange={(val) => onFilterChange('cidade', val)}
            searchable
            placeholder="Selecione cidades..."
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Advogado
          </label>
          <input
            type="text"
            placeholder="Nome do advogado..."
            value={filters.advogado || ''}
            onChange={(e) => onFilterChange('advogado', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Polo Passivo
          </label>
          <input
            type="text"
            placeholder="Nome da parte..."
            value={filters.poloPassivo || ''}
            onChange={(e) => onFilterChange('poloPassivo', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Valor Estimado (R$)
          </label>
          <div className="flex space-x-2">
            <input
              type="number"
              placeholder="Min"
              value={filters.valorEstimadoMin || ''}
              onChange={(e) =>
                onFilterChange(
                  'valorEstimadoMin',
                  e.target.value ? parseFloat(e.target.value) : undefined,
                )
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900"
            />
            <input
              type="number"
              placeholder="Max"
              value={filters.valorEstimadoMax || ''}
              onChange={(e) =>
                onFilterChange(
                  'valorEstimadoMax',
                  e.target.value ? parseFloat(e.target.value) : undefined,
                )
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Score do Processo
          </label>
          <div className="flex space-x-2">
            <input
              type="number"
              placeholder="Min"
              value={filters.scoreProcessoMin || ''}
              onChange={(e) =>
                onFilterChange(
                  'scoreProcessoMin',
                  e.target.value ? parseInt(e.target.value) : undefined,
                )
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900"
              min="0"
              max="100"
            />
            <input
              type="number"
              placeholder="Max"
              value={filters.scoreProcessoMax || ''}
              onChange={(e) =>
                onFilterChange(
                  'scoreProcessoMax',
                  e.target.value ? parseInt(e.target.value) : undefined,
                )
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900"
              min="0"
              max="100"
            />
          </div>
        </div>

        <div className="flex items-end">
          <button
            onClick={handleReset}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition-colors"
          >
            Limpar Filtros
          </button>
        </div>
      </div>

      {Object.keys(filters).length > 0 && (
        <div className="mt-4 flex items-center text-sm text-gray-600">
          <span className="font-medium">Filtros ativos:</span>
          <span className="ml-2">
            {Object.keys(filters).length} filtro(s) aplicado(s)
          </span>
        </div>
      )}
    </div>
  );
}
